import styled from 'styled-components'
import { PrimaryButton, OutlineButton, Heading3 } from '@chegg/fanta'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'

export const Container = styled.div``
export const DescriptionContainer = styled.div``
export const CTAContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${FantaTheme.spacing.fanta.xl};
`

export const CancelButton = styled(OutlineButton)`
  border-color: ${({ theme }) => theme.Colors.primaryColor};
  color: ${({ theme }) => theme.Colors.primaryColor};
  margin-right: 1rem;
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
    background-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
  }
`
export const SubmitButton = styled(PrimaryButton)`
  border-color: ${({ theme }) => theme.Colors.primaryColor};
  background-color: ${({ theme }) => theme.Colors.primaryColor};
  &:hover {
    border-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
    background-color: ${({ theme }) => theme.Colors.forFonts.fColor16};
  }
`

export const Header = styled(Heading3)`
  font-size: 28px; /* not fanta */
  margin-top: 0;
  margin-bottom: ${FantaTheme.spacing.fanta.md};
`
